export default __webpack_public_path__ + "static/media/exterior13.43601763.webp";